// 乔木类标签选项
export const treeOptions = {
    size: [
      { label: '所有尺寸', value: 'all' },
      { label: '小型乔木', value: '小型乔木' },
      { label: '大型乔木', value: '大型乔木' }
    ],
    shape: [
      { label: '所有形态', value: '' },
      { label: '丛生', value: '丛生' },
      { label: '独杆', value: '独杆' }
    ],
    color: [
      { label: '所有颜色', value: '' },
      { label: '绿', value: '绿' },
      { label: '黄', value: '黄' },
      { label: '粉', value: '粉' },
      { label: '红', value: '红' },
      { label: '白', value: '白' },
      { label: '橙', value: '橙' },
      { label: '紫', value: '紫' }
    ]
  };
  
  // 草灌类标签选项
  export const grassOptions = {
    shape: [
      { label: '所有形态', value: '' },
      { label: '独杆', value: '独杆' },
      { label: '标准段', value: '标准端' },
      { label: '灌木球', value: '灌木球' }
    ],
    color: [
      { label: '所有颜色', value: '' },
      { label: '绿', value: '绿' },
      { label: '黄', value: '黄' },
      { label: '粉', value: '粉' },
      { label: '红', value: '红' },
      { label: '白', value: '白' },
      { label: '橙', value: '橙' },
      { label: '紫', value: '紫' },
      { label: '彩', value: '彩' },
      { label: '银', value: '银' }
    ]
  };
  
  // 建筑类标签选项
  export const buildingOptions = {
    type: [
      { label: '所有类型', value: '', name: [{ label: '所有名称', value: '' }] },
      { label: '墙', value: '墙', name: [{ label: '景观墙', value: '景观墙' }, 
        { label: '围墙', value: '围墙' }] },
      { label: '亭廊', value: '亭廊', name: [{ label: '仿古亭', value: '仿古亭' },
        { label: '现代亭', value: '现代亭' },
        { label: '廊架', value: '廊架' }] },
      { label: '桥', value: '桥', name: [{ label: '浅桥', value: '浅桥' },
        { label: '拱桥', value: '拱桥' }] },
      { label: '水景', value: '水景', name: [{ label: '水景小品', value: '水景小品' },
        { label: '跌水水景', value: '跌水水景' },
        { label: '池塘水景', value: '池塘水景' },
        { label: '喷泉水景', value: '喷泉水景' }] },
      { label: '树池', value: '树池', name:[{ label: '独立树池', value: '独立树池' },
        { label: '标准段树池', value: '标准段树池' }] },
      { label: '其他', value: '其他', name:[{ label: '其他', value: '' }] }
    ]
  };
  
  // 家具类标签选项
  export const furnitureOptions = {
    type: [
      { label: '所有类型', value: '', name: [{ label: '所有名称', value: '' }] },
      { label: '桌椅', value: '桌椅', name: [{ label: '座椅组合', value: '座椅组合' },
        { label: '单椅', value: '单椅' }] },
      { label: '装饰', value: '装饰', name: [{ label: '花箱', value: '花箱' },
        { label: '摆件', value: '摆件' },
        { label: '人和动物', value: '人和动物' }] },
      { label: '灯具', value: '灯具', name: [{ label: '高杆灯', value: '高杆灯' },
        { label: '草坪灯', value: '草坪灯' },
        { label: '氛围灯', value: '氛围灯' }] },
      { label: '标识牌', value: '标识牌', name: [{ label: '导视牌', value: '导视牌' },
        { label: '精神堡垒', value: '精神堡垒' },
        { label: '大门', value: '大门' }] },
      { label: '器材设备', value: '器材设备', name: [{ label: '健身器材', value: '健身器材' },
        { label: '儿童游乐', value: '儿童游乐' }] },
      { label: '其他', value: '其他', name: { label: '其他', value: '' } }
    ]
  };

  // 景石标签选项
  export const stoneOptions = {
    type: [
      { label: '所有类别', value: 'all' },
      { label: '景石', value: '景石' },
      { label: '现代雕塑', value: '现代雕塑' },
      { label: '组合', value: '组合' },
      { label: '其他', value: '其他' }
    ],
    size: [
      { label: '所有尺寸', value: '' },
      { label: '大', value: '大' },
      { label: '小', value: '小' }
    ]
  };